import PropTypes from 'prop-types';
import { Card, Img, Description, Text } from './styled';

const NewsItem = (props) => {
  const { picture, description, url, text } = props;

  return (
    <Card>
      <a href={url} target="_blank" rel="noopener noreferrer">
        <Img src={picture.guid} alt={description} />
      </a>
      <Description>
        <a href={url} target="_blank" rel="noopener noreferrer">
          {description}
        </a>
      </Description>
      <Text dangerouslySetInnerHTML={{ __html: text }} />
    </Card>
  );
};

NewsItem.propTypes = {
  picture: PropTypes.shape({
    guid: PropTypes.string.isRequired,
  }).isRequired,
  description: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default NewsItem;
